module.exports = __webpack_public_path__ + "img/question-circle.3ea471d1.svg";